// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3079":"d1d43ccf60793d2d","7045":"da290ad6b12cecde"}[chunkId] + ".css";
};